// 帮助中心
<template>
  <div class="help">
    <van-nav-bar
      :title="$t('menu.help')"
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
      z-index="5"
    />
    <section class="container">
      <div class="card">
        <div class="flex justify-between align-center">
          <!-- <div class="flex align-center">
            <div class="avatar"><img :src="userInfo.headPortrait" /></div>
            <div class="info flex-column">
              <div>Hi.{{ userInfo.name }}</div>
            </div>
            <div class="info" @click="$router.push('/login')">{{ $t('login.title') }}</div>
          </div> -->
          <van-button
            size="small"
            round
            :icon="require('@/assets/images/icon/serve.png')"
            color="linear-gradient(30deg, #3EE191, #24DEDD)"
            @click="$router.push('feedback')"
            >Connect</van-button
          >
        </div>
        <span class="desc">If any questions, please feel free contact us.</span>
      </div>
    </section>
    <div class="title">Q&A</div>
    <van-cell-group inset>
      <van-cell
        v-for="item in list"
        :key="item.id"
        :title="item.problem"
        title-style="font-weight: bold;"
        is-link
        @click="linkToDetail(item)"
      />
    </van-cell-group>
    <div class="flex justify-center bottom" style="margin-top: 37px">
      <div class="link" @click="show = true">Reset your device</div>
      <!-- <van-button plain round color="#000" @click="init">Change batch</van-button> -->
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="tips-wrapper" @click.stop>
        <div class="dialog__title">Caution!</div>
        <div class="dialog__content">
          <p>
            1. Please check if another device is in use around that prevents
            reset other devices.
          </p>
          <p>
            2. Please click the reset button and vape your device to wake
            Bluetooth. After that, your device will reset successfully.
          </p>
        </div>
        <div class="dialog__footer">
          <div class="flex justify-between">
            <div></div>
            <div class="confirm flex">
              <div class="cancel" @click="show = false">Cancel</div>
              <div style="margin-left: 25px" @click="reset">Reset</div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getHelpList, clearEuipmentInfo } from "@/api";
export default {
  name: "Help",
  data() {
    return {
      show: false,
      list: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  mounted() {
    window.resetTheDevice_Succeed = this.resetTheDevice_Succeed_Callback; // 注册 "重置 周围任意一个能连接上 的设备 成功" 的回调函数
    window.resetTheDevice_Failed = this.resetTheDevice_Failed_Callback; // 注册 "重置 周围任意一个能连接上 的设备 失败" 的回调函数
    this.init();
  },
  methods: {
    // 初始化列表
    async init() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      await getHelpList()
        .then((res) => {
          this.loading = false;
          this.list = res.data;
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    linkToDetail(item) {
      this.$router.push({
        name: "helpDetail",
        query: {
          id: item.id,
        },
      });
    },
    /** 重置 周围任意一个能连接上 的设备 成功回调(宿主是调用方) */
    resetTheDevice_Succeed_Callback(equipmentCode) {
      clearEuipmentInfo({
        equipmentCode: equipmentCode,
      }).then((res) => {
        if (res.code === 200) {
          this.show = false;
          this.$toast("operation succeeded");
        }
      });
    },
    /** 重置 周围任意一个能连接上 的设备 失败回调(宿主是调用方) */
    resetTheDevice_Failed_Callback(x) {
      this.$toast("operation failed");
    },
    // 重置设备
    reset() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.$store.commit("setIdOfConnectedDevice", -1);
      window.webkit.messageHandlers.try2ResetTheDevice.postMessage("Meaningless"); // 通知宿主: 重置 周围任意一个能连接上 的设备
    },
  },
};
</script>

<style lang="less">
.help {
  .van-hairline--bottom {
    &:after {
      border-bottom-width: 0;
    }
  }
  .card {
    position: relative;
    background: #fff;
    padding: 28px 33px;
    border-radius: 15px;
    margin-bottom: 15px;
    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      margin-right: 30px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #969696;
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    .info {
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-size: 25px;
      color: #010101;
    }
    .desc {
      display: block;
      margin-top: 20px;
      font-size: 24px;
      line-height: 1.5;
    }
    // width: 100%;
    // box-sizing: border-box;
    // background: #fff;
    // border-radius: 10px;
    // margin-bottom: 20px;
    // overflow: hidden;
    .card-item {
      height: 100%;
      .left {
        width: 8%;
        border-right: 1px solid #f5f5f5;
        .index {
          font-size: 26px;
          color: #fff;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #00aaff;
        }
        .select {
          padding: 0;
          height: calc(~"100% - 50px");
        }
      }
      .right {
        width: 100%;
        .content {
          .content-title {
            padding: 0 70px;
            font-weight: bold;
            font-size: 26px;
            height: 80px;
            line-height: 80px;
            border-bottom: 1px solid #f5f5f5;
          }
          .content-item {
            padding-left: 70px;
            .content-label {
              line-height: 1.5;
              color: #d0d0d0;
              font-size: 22px;
            }
            .content-value {
              line-height: 1.5;
              font-size: 22px;
              margin-bottom: 20px;
            }
          }
        }
        .btn {
          border-top: 1px solid #f5f5f5;
          .disabled {
            opacity: 0.5;
          }
          .btn-item {
            border-right: 1px solid #f5f5f5;
            padding: 20px 0;
            text-align: center;
            img {
              width: 36px;
              height: 36px;
            }
            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }
  }
  .title {
    padding: 0px 33px 20px;
    font-size: 40px;
    font-weight: bold;
  }
  .bottom {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    .link {
      color: #707070;
      text-decoration: underline;
    }
  }
}
</style>
